import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";
import {
  DEFAULT_COUNTRY,
  GLOBAL_COUNTRY_ISO,
  GLOBAL_COUNTRY_NAME,
  ALL_COUNTRIES_ISO,
  ALL_COUNTRIES_NAME,
} from "./constants";
import { COUNTRY_LIST } from "@stadium/constants/country-list";
import { NON_INTERNATIONAL_COUNTRIES_ISO } from "@stadium/constants/country";

export const getOrderedStateOptions = ({
  data = [],
  textAttr = "abbr",
  valueAttr = "abbr",
  filterAttrs = ["abbr", "name"],
  otherAttrs = [],
  getText,
}) => {
  let dataOptions = [];
  data.forEach((dataObj) => {
    const text = typeof getText === "function" ? getText(dataObj) : dataObj[textAttr];
    const name = dataObj[textAttr];
    const value = dataObj[valueAttr];
    const filterAttrsData = [...filterAttrs, ...otherAttrs].reduce(
      (acc, curr) => ({ ...acc, [curr]: dataObj[curr] }),
      {},
    );
    dataOptions = [...dataOptions, { text, value, name, ...filterAttrsData }];
  });
  dataOptions = sortBy(dataOptions, "name");
  return dataOptions;
};

export const isDefaultCountry = (country) => {
  return country.iso === DEFAULT_COUNTRY.iso;
};

export const defaultCountryObject = (countries) =>
  countries?.find(({ iso }) => iso === DEFAULT_COUNTRY.iso) || DEFAULT_COUNTRY;

export const getCountryDataFromName = (countries, userBaseCountry) =>
  countries?.find((country) => country?.name?.toLowerCase() == userBaseCountry?.toLowerCase()) ||
  defaultCountryObject(countries);

export const getCountryDetailsUsingIso = (countryList, countryIso) => {
  return countryList?.find((countryItem) => countryItem.iso === countryIso);
};

export const getCountryNameUsingIso = (iso) => {
  const countyIso = iso?.toUpperCase();

  if (countyIso === GLOBAL_COUNTRY_ISO) {
    return GLOBAL_COUNTRY_NAME;
  }
  if (countyIso === ALL_COUNTRIES_ISO) {
    return ALL_COUNTRIES_NAME;
  }
  return iso && COUNTRY_LIST[countyIso]?.name;
};

export const getCountryDetailsUsingId = (countryList, countryId) => {
  return countryList?.find((country) => country.id === Number(countryId));
};

export const isGlobalCountry = (country) =>
  country?.iso?.toLowerCase() === GLOBAL_COUNTRY_ISO.toLowerCase();

const isInternational = (country) => !NON_INTERNATIONAL_COUNTRIES_ISO.includes(country.iso);

export const getCountriesWithAdditionalData = ({ configData = {}, zonesData = {} }) => {
  const { countries } = configData;
  const updatedCountries = countries?.map((country) => {
    const zone = zonesData[country.id] || {};
    return {
      ...country,
      international: isInternational(country),
      ...(!isEmpty(zone) && { zoneId: zone.id }),
    };
  });

  const globalCountryZoneId = Object.values(zonesData).find(
    (zone) => zone.uniqCountryIso.toLowerCase() === GLOBAL_COUNTRY_ISO.toLowerCase(),
  )?.id;

  return { ...configData, countries: updatedCountries, globalCountryZoneId };
};
